// extracted by mini-css-extract-plugin
export var bgLoading = "index-module--bg-loading--cf0b7";
export var borderLoading = "index-module--border-loading--d7e6c";
export var breakBorderLoading = "index-module--break-border-loading--c64c3";
export var gradient = "index-module--gradient--b96c6";